import React from 'react'
import { Button, TextField } from '@mui/material'
import { useForm } from 'react-hook-form'
import _ from 'lodash'
import { ActiveTarget } from './AutomationConstructor'
import { Node } from './canvas-utils'

interface DelayEditFormProps {
    target: ActiveTarget | null;
    onSave: (node: Node) => void;
}

const DelayEditForm = ({ target, onSave }: DelayEditFormProps) => {
    const { register, handleSubmit, watch, control } = useForm({
        defaultValues: {
            delay: _.get(target, "entity.data.payload.delay", 0),
        },
        mode: "onChange",
    });

    const onSubmit = (formInput: any) => {
        console.log("formInput", formInput);
        onSave({
            ...(target?.entity as Node),
            data: {
                type: "DELAY",
                payload: {
                    delay: Number(formInput.delay),
                },
            },
        });
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4">
            <TextField
                type="number"
                {...register("delay")}
                fullWidth
                placeholder="Введите задержку"
                label="Задержка в секундах"
            />
            <Button type="submit" variant="contained" color="primary" >
                Сохранить
            </Button>
        </form>
    )
}

export default DelayEditForm
